import { html } from 'lit';
const ColorPicker =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.607 3.637a2.57 2.57 0 0 0-3.636 0l-1.667 1.666a2.57 2.57 0 0 1-3.251.318c-.23-.154-.544-.16-.74.036l-.656.656a.5.5 0 0 0 0 .708l1.394 1.393-7.39 7.39a2.75 2.75 0 0 0-.456 3.285l-1.043 1.043a.75.75 0 1 0 1.06 1.06l1.043-1.043a2.75 2.75 0 0 0 3.286-.457l7.389-7.389 1.283 1.284a.5.5 0 0 0 .707 0l.657-.657c.195-.195.19-.51.036-.739-.672-1-.567-2.367.317-3.251l1.667-1.667a2.57 2.57 0 0 0 0-3.636M5.722 16.864l7.39-7.389 1.767 1.768-7.389 7.389a1.25 1.25 0 0 1-1.768-1.768" clip-rule="evenodd"/>
  </svg>
`;
export default ColorPicker;
